import { configureDatadog } from '@storebrand-digital/common-datadog';
import { Environment } from '@storebrand-digital/common-datadog/dist/environment';

export const initDatadog = () => {
  configureDatadog({
    environment: getDatadogEnvironment(),
    // The clientToken provided by Datadog RUM
    clientPublicToken: 'pub3611ba63fb3e9971f9346b1b4f42008a',
    // The applicationId provided by Datadog RUM.
    appId: '246a2d68-aa5d-46aa-b4f8-9a53a86e76b8',
    appName: 'insurance-claim-web',
    // Set to commit hash or something similar.
    appVersion: __APP_VERSION__,
    // Optional and default false. Set to true if you
    // want to activate logging in addition to RUM.
    configureLogging: true,
    // Optional and default "all" Set which console logs to forward to Datadog.
    forwardConsoleLogs: ['error', 'warn'],
    // Optional and default false. Set to true only if you want to override
    // default pageView handling (SPA and Hashtag URL).
    trackViewsManually: false
  });
};

const getDatadogEnvironment = (): Environment => {
  const env = window.env.ENVIRONMENT;
  switch (env) {
    case 'e2e':
    case 'development':
    case 'local':
      return 'development';
    case 'client-t':
    case 'client-ts':
      return 'client-t';
    case 'production':
    default:
      return 'production';
  }
};
